/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import BaseSelect from 'shared/ui/components/form-components/BaseSelect.vue';
import WizardStep from 'shared/ui/components/WizardStep.vue';
import WorkspacesList from 'ui/components/WorkspacesList.vue';

// Utils
import { get } from 'lodash';

/**
 * Original Specifications:
 *
 * This screen will have a selector for the user to choose the organization they want to create the workspace
 * for and a list of 15 (5 rows 3 columns) of thumbnails of the template card (can’t be selected or interacted
 * with in any way)
 *
 * Selector:
 * - If the user is a admin of only one organization then the selector will be hidden.
 * - If the user is an admin of multiple orgs a placeholder will be displayed in the selector.
 * - This is a mandatory field.
 *
 * After the user has selected the organization, the thumbnails disappear and the templates available for
 * the members of the selected org will be displayed. The first card will be automatically selected after
 * they load. Infinite scroll loading of 15 items at a time. The templates will be sorted alphabetically
 * (a → z) showing first all the SpotMe generated templates and then the others (ie: SpotMe A, SpotMe B,
 * SpotMe C, PWC A, Daimler D, Novartis S,…)
 *
 * Cards:
 *      Image:
 *          - Use uploaded image as the background with white background
 *          - If no image was a uploaded, use a random color (only Lightness 300) from the palette and apply it to the background
 *      Details:
 *          - First row: name of the org the template was created for
 *          - Truncates with ellipses at the end of the first line
 *          - Second row: Name of the template
 *          - Truncates with ellipses at the end of the second line
 *          - Third row: Short description of the template
 *          - Truncates with ellipses at the end of the second line
 *
 * @category ui.components.wizards.create-workspace
 * @exports Template
 * @component
 */
const __vue_script__ = {
    name: 'Templates',

    components: { WorkspacesList, BaseSelect },

    extends: WizardStep,

    data() {
        return {
            currentFilter: 'all',
            loading: false,
            organizations: [],
            templates: {
                user: [],
                global: []
            },

            form: {
                organization: null,
                template: null
            }
        };
    },

    computed: {
        /**
         * @returns {String[]} the template types to list
         */
        filterKeys() {
            return this.currentFilter === 'all' ? ['user', 'global'] : [this.currentFilter];
        },

        /**
         * @returns {Boolean} whether to display the filters or not
         */
        showFilters() {
            return this.templates.global.length !== 0 && this.templates.user.length !== 0;
        },

        /**
         * @returns {String[]} the current template selection
         */
        templateSelection() {
            if (this.form.template) {
                return [this.form.template.id];
            }

            return [];
        }
    },

    created() {
        this.organizations = this.$services.user.getManagedOrgs();

        if (this.organizations.length === 1) {
            this.form.organization = this.organizations[0];
            this.orgChanged();
        }
    },

    methods: {
        /**
         * Organization changed callback
         */
        orgChanged() {
            // Only load templataes when an organization is selected.
            // Reset template choice.
            this.resetStatus();
            this.loadTemplates();
        },

        /**
         * Resets the pager to default values
         */
        resetStatus() {
            this.form.template = null;
            this.templates = {
                user: [],
                global: []
            };
        },

        /**
         * Load templates list from BE.
         */
        async loadTemplates() {
            try {
                this.loading = true;
                const org = this.$services.org.getNameFromId(this.form.organization._id);
                const templates = await this.$services.template.getTemplatesForSelection(org, this.$i18n.locale);

                for (const template of templates) {
                    if (template.visibility === 'global') {
                        this.templates.global.push(template);
                    } else {
                        this.templates.user.push(template);
                    }
                }

                // First template auto-selection upon loading
                if (!this.form.template) {
                    if (this.templates.user.length) {
                        this.selectTemplate(this.templates.user[0]);
                    } else {
                        this.selectTemplate(this.templates.global[0]);
                    }
                }

            } catch (error) {
                this.error = get(error, 'response.data.error') || error.message;

            } finally {
                this.loading = false;
            }
        },

        /**
         * Selects the template for the workspace.
         *
         * @param {Object} template the template to mark as selected
         * @param {MouseEvent} [$event] an optional click event
         */
        selectTemplate(template, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }

            this.form.template = template;
            this.validate(true);
        },

        /**
         * Validates the form.
         *
         * @param {Boolean} [silent=false] whether to trigger the normal validation or the silent one
         *
         * @override
         */
        async validate() {
            let validity = true;

            if (this.organizations.length > 1) {
                validity = await this.$refs.form.validate();
            }

            if (!this.form.template) {
                validity = false;
            }

            return this.valid = validity;
        },

        /**
         * Filters the templates with the given flag
         *
         * @param {String} flag the filter to apply
         */
        filter(flag) {
            console.info('[Templates] filtering by', flag);

            this.currentFilter = flag;
        },

        /**
         * This handler is called upon form submission.
         *
         * @override
         */
        async submit() {
            await this.validate();

            if (!this.form.template.packages) {
                const { template } = await this.$services.template.getTemplateDetails(this.form.template.id, true, true);

                this.form.template = template;
            }

            return true;
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('validation-observer',{ref:"form",staticClass:"template-choice",attrs:{"tag":"form"},on:{"submit":function($event){$event.preventDefault();return _vm.submit.apply(null, arguments)}}},[_c('div',{staticClass:"grouped-controls"},[_c('div',{staticClass:"form-groups"},[_c('validation-provider',{staticClass:"organization",attrs:{"rules":"required","slim":true,"name":"organization"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [(_vm.organizations.length > 1)?_c('base-select',{attrs:{"label":_vm.$t('wizards.create_workspace.form.organization'),"placeholder":_vm.$t('wizards.create_workspace.form.organization_placeholder'),"name":"organization","validations":"required","options":_vm.organizations,"options-label":"display_name","track-by":"_id","errors":errors,"focused":_vm.focus == 'organization'},on:{"input":_vm.orgChanged},model:{value:(_vm.form.organization),callback:function ($$v) {_vm.$set(_vm.form, "organization", $$v)},expression:"form.organization"}}):_vm._e()]}}])}),(_vm.showFilters && _vm.form.organization)?_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v(" ")]),_c('div',{staticClass:"btn-group"},[_c('a',{staticClass:"btn",class:[_vm.currentFilter === 'all' ? 'btn-primary' : ''],on:{"click":function($event){return _vm.filter('all')}}},[_vm._v(_vm._s(_vm.$t('wizards.create_workspace.filters.all')))]),_c('a',{staticClass:"btn",class:[_vm.currentFilter === 'user' ? 'btn-primary' : ''],on:{"click":function($event){return _vm.filter('user')}}},[_vm._v(_vm._s(_vm.$t('wizards.create_workspace.filters.user')))]),_c('a',{staticClass:"btn",class:[_vm.currentFilter === 'global' ? 'btn-primary' : ''],on:{"click":function($event){return _vm.filter('global')}}},[_vm._v(_vm._s(_vm.$t('wizards.create_workspace.filters.global')))])])]):_vm._e()],1)]),(!_vm.form.organization)?_c('div',{staticClass:"templates-list fake"},[_c('div',{staticClass:"listing-grid"},_vm._l((6),function(i){return _c('div',{staticClass:"template-placeholder"},[_c('div',{staticClass:"banner"}),_c('div',{staticClass:"fake-content"},[_c('div',{staticClass:"line line-1"}),_c('div',{staticClass:"line line-2"}),_c('div',{staticClass:"line line-3"}),_c('div',{staticClass:"line line-4"})])])}),0)]):_vm._e(),_vm._l((_vm.filterKeys),function(filter){return (_vm.form.organization && _vm.templates[filter].length)?_c('div',{staticClass:"templates-list"},[_c('workspaces-list',{attrs:{"mode":"WorkspaceTemplate","uid-prefix":"tpl","workspaces":_vm.templates[filter],"selection":_vm.templateSelection},on:{"click":_vm.selectTemplate}},[_c('h4',{staticClass:"separator"},[_vm._v(_vm._s(_vm.$t(("wizards.create_workspace.filters." + filter))))])])],1):_vm._e()})],2)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "Templates.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__